import { render, staticRenderFns } from "./DisciplineInput.vue?vue&type=template&id=524a9d57"
import script from "./DisciplineInput.vue?vue&type=script&lang=js"
export * from "./DisciplineInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports